import * as runtime from '@/api/runtime'

/**
 * DAMファイルDL
 */
export class BatchReserveInfoExtractApi extends runtime.BaseAPI {
  async return(): Promise<string> {
    const response = await this.requestGet(
      `/batch/reserve/reserve-info-extract`
    )

    return new runtime.JSONApiResponse(
      response,
      jsonValue => jsonValue.url
    ).value()
  }
}
